export enum LTMTransactionStatus {
    CANCELED = "CANCELED",
    APPROVED = "APPROVED",
    DENIED = "DENIED",
    AUTHORIZED = "AUTHORIZED",
    PENDING = "PENDING",
    CONFIRMED = "CONFIRMED",
    WAITING = "WAITING",
    EXPIRED = "EXPIRED",
    ERROR = "ERROR",
    GATEWAY_FAILED = "GATEWAY_FAILED",
    APPROVED_MANUAL = "APPROVED_MANUAL",
}